import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { constantvalues } from "../../../const";
import { environment } from "../../environments/environment.development";
import { ChangePackage, DtoFeature, DtoSubCategory, MetricPayload, PackagePayload, SubCategoryPayload } from "../../../models/package-center.model";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class PackageService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }

    getAllFeatures(sectorId: number):Observable<DtoFeature[]> {
        return this.httpClient.get<DtoFeature[]>(
            `${this.baseURL}${constantvalues.API_URL.GET_FEATURES}/${sectorId}`);
    }
    getModules(sectorId: number) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_MODULES}/${sectorId}`);
    }

    getSubCategories(payload: any) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.GET_SUBCATEGORIES}`, payload);
    }

    getSubCategoriesOfPackage(payload: any, packageId: number) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.GET_SUBCATEGORIES}/${packageId}`, payload);
    }

    getMetrics(payload: MetricPayload | any) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.GET_METRICS}`, payload);
    }

    getPackages(sectorId: number, applyPackage: number = 1) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CRUD_PACKAGE}/${sectorId}/${applyPackage}`);
    }

    getPackageByPackageId(packageId: number) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.PACKAGE}/${packageId}`);
    }

    createPackage(packageDetails: PackagePayload) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_PACKAGE}`, packageDetails);
    }

    updatePackage(packageDetails: PackagePayload) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_PACKAGE}`, packageDetails);
    }

    deletePackage(packageId: number) {
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.CRUD_PACKAGE}`, {
            params: {
                packageId: packageId
            }
        });
    }

    updateAssignedPackage(packageDetails: ChangePackage) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.PACKAGE_ROOT_URL}/package-change/${packageDetails.packageId}`, packageDetails);
    }

    getPackageInformation(packageId: number) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.PACKAGE_ROOT_URL}/package-information/${packageId}`);
    }

    
    getToolkit(clientReference:string, toolkitName:string):Observable<DtoSubCategory>{
        return this.httpClient.get<DtoSubCategory>(`${this.baseURL}${constantvalues.API_URL.PACKAGE_ROOT_URL}/get-toolkit-for-client/${clientReference}/${toolkitName}`)
    }

    GetPackageInformationForClient(clientReference:string, packageId: number) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.PACKAGE_ROOT_URL}/package-information-for-client/${clientReference}/${packageId}`);
    }

    getPackageInformationForRole(roleId: string) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.PACKAGE_ROOT_URL}/package-information-roles/${roleId}`);
    }

    
    getPackageInformationForClientAndRole(clientReference:string, roleId: string) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.PACKAGE_ROOT_URL}/package-information-roles-for-client/${clientReference}/${roleId}`);
    }



    updatePackageStatus(packageId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_PACKAGE}/${packageId}`, null);
    }

    approvePackageUpgrade(packageChangeRequestId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.APPROVE_UPGRADE_PACKAGE}/${packageChangeRequestId}`, null);
    }

    approveRoleCreationRequest(roleAddRequestId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.APPROVE_ADD_ROLE_REQUEST}/${roleAddRequestId}`, null);
    }

    declineRoleCreationRequest(roleAddRequestId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.DECLINE_ADD_ROLE_REQUEST}/${roleAddRequestId}`, null);
    }

    declinePackageUpgrade(packageChangeRequestId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.DECLINE_UPGRADE_PACKAGE}/${packageChangeRequestId}`, null);
    }

    checkIfAnyActiveRequestExists(email: string) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CHECK_ACTIVE_REQUEST_EXISTS}/${email}`);
    }

    getAvailableSubscriptionForPackage(packageId: number): Promise<any> {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.ACTIVE_SUBSCRIPTION}/${packageId}`).pipe(
            map((response) => response)
        ).toPromise();
    }
}